// extracted by mini-css-extract-plugin
export default {"email":"styles_email__734Ta"};